import { ChipsContainer } from "./ChipsContainer";
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { RoomManager } from "../../../managers/RoomManager";
import { AudioManager } from "../../../managers/AudioManager";
import { BananaSpine } from "../banana/BananaSpine";

export class PlayerContainer extends Phaser.GameObjects.Container {

    public isDealer: boolean;
    public id: string;
    public positionInTable: number;
    public credibility: number;

    private creditsLabel: Phaser.GameObjects.Text;
    private prevHandLabel: string;
    private handLabel: Phaser.GameObjects.Text;
    private cards: Phaser.GameObjects.Image[];
    private frames: Phaser.GameObjects.Image[];
    private chipsContainer: ChipsContainer;
    private dealerChip: Phaser.GameObjects.Image;
    private confetti: Phaser.GameObjects.Sprite;

    private container: Phaser.GameObjects.Container;
    private capsuleContainer: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene, x: number, y: number, positionInTable: number, id: string) {

        super(scene);

        this.setScale(.9 * GameVars.scaleX, .9);

        this.credibility = 100;

        this.x = x;
        this.y = y;
        this.id = id;
        this.isDealer = false;
        this.positionInTable = positionInTable;

        this.confetti = this.scene.add.sprite(0, 0, "texture_atlas_1", "confetti_01.png");
        this.add(this.confetti);

        this.confetti.on("animationcomplete", () => {
            this.confetti.visible = false;
        }, this);

        this.cards = [];
        this.frames = [];

        this.prevHandLabel = "";

        this.container = new Phaser.GameObjects.Container(this.scene);
        this.add(this.container);

        const card1 = new Phaser.GameObjects.Image(this.scene, -65, -40, "texture_atlas_2");
        card1.visible = false;
        card1.setScale(.9);
        this.container.add(card1);
        this.cards.push(card1);

        const card2 = new Phaser.GameObjects.Image(this.scene, 15, -40, "texture_atlas_2");
        card2.visible = false;
        card2.setScale(.9);
        this.container.add(card2);
        this.cards.push(card2);

        // CAPSULE

        this.capsuleContainer = new Phaser.GameObjects.Container(this.scene);
        this.container.add(this.capsuleContainer);

        let capsule = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "capsule_player.png");
        this.capsuleContainer.add(capsule);

        const credits = RoomManager.getPlayer(id).chips;

        this.handLabel = new Phaser.GameObjects.Text(this.scene, 0, -22, "", {fontFamily: "Oswald-Medium", fontSize: "18px", color: "#8d8065"});
        this.handLabel.setOrigin(.5);
        this.capsuleContainer.add(this.handLabel);

        this.creditsLabel = new Phaser.GameObjects.Text(this.scene, 0, 8, GameVars.formatNumber(credits), {fontFamily: "Oswald-Medium", fontSize: "30px", color: "#8d8065"});
        this.creditsLabel.setOrigin(.5);
        this.capsuleContainer.add(this.creditsLabel);

        // LOS CHIPS 
        this.chipsContainer = new ChipsContainer(this.scene, false, true, this.id);
        this.chipsContainer.visible = false;
        this.container.add(this.chipsContainer);

        this.dealerChip = new Phaser.GameObjects.Image(this.scene, 90, -100, "texture_atlas_1", "chip_dealer.png");
        this.dealerChip.visible = this.isDealer;
        this.container.add(this.dealerChip);

        this.alpha = 0;

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(): void {

        // 
    }

    public setTurn(value: boolean): void {

        if (value) {
            this.parentContainer.bringToTop(this);
        }
    }

    public updateChipsState(): void {

        this.chipsContainer.updateChipsState();
    }

    public addCardsFrames(cards: any[]): void {

        let playerCards = RoomManager.getPlayer(this.id).cards; 

        for (let i = 0; i < cards.length; i++) {
            if (playerCards[0] === (cards[i].value + cards[i].suit)) {

                const card = new Phaser.GameObjects.Image(this.scene, this.cards[0].x, this.cards[0].y, "texture_atlas_1", "frame_winner_hand.png");
                card.angle = this.cards[0].angle;
                card.setScale(this.cards[0].scaleX, this.cards[0].scaleY);
                this.container.add(card);
                this.frames.push(card);
            }

            if (playerCards[1] === (cards[i].value + cards[i].suit)) {

                const card = new Phaser.GameObjects.Image(this.scene, this.cards[1].x, this.cards[1].y, "texture_atlas_1", "frame_winner_hand.png");
                card.angle = this.cards[1].angle;
                card.setScale(this.cards[1].scaleX, this.cards[1].scaleY);
                this.container.add(card);
                this.frames.push(card);
            }
        }

        this.container.bringToTop(this.cards[1]);

        if (this.frames.length > 0  && playerCards[1] === this.frames[0].name) {
            this.container.bringToTop(this.frames[0]);
        } else if (this.frames.length > 1  && playerCards[1] === this.frames[1].name) {
            this.container.bringToTop(this.frames[1]);
        }

        this.container.bringToTop(this.cards[0]);
        
        if (this.frames.length > 0  && playerCards[0] === this.frames[0].name) {
            this.container.bringToTop(this.frames[0]);
        } else if (this.frames.length > 1  && playerCards[0] === this.frames[1].name) {
            this.container.bringToTop(this.frames[1]);
        }
    }

    public addPlayerCards(): void {

        if (!RoomManager.getPlayer(this.id)) {
            return;
        }

        this.cards[0].x = -1;
        this.cards[1].x = -1;

        this.cards[0].y = GameConstants.GAME_HEIGHT / 2 - this.y - 5;
        this.cards[1].y = GameConstants.GAME_HEIGHT / 2 - this.y - 5;

        this.cards[0].angle = 0;
        this.cards[1].angle = 0;

        this.cards[0].setScale(.9);
        this.cards[1].setScale(.9);

        this.cards[0].visible = true;
        this.cards[1].visible = true;
        
        this.cards[0].alpha = 0;
        this.cards[1].alpha = 0;

        this.cards[0].setFrame("card-back.png");
        this.cards[1].setFrame("card-back.png");

        let cards = RoomManager.getPlayer(this.id).cards;
        let delay = RoomManager.getPlayer(this.id).position * 200;

        this.scene.tweens.add({
            targets: this.cards[0],
            x: -65,
            y: -40,
            ease: Phaser.Math.Easing.Quadratic.In,
            duration: 250 / GameVars.gameSpeed,
            delay: delay / GameVars.gameSpeed,
            onComplete: () => {
                this.cards[0].setFrame(GameVars.cardFrameName(cards[0]) + ".png");
                AudioManager.playSound("card_reveal_" + (Math.floor(Math.random() * 3) + 1));
            }
        });

        this.scene.tweens.add({
            targets: this.cards[1],
            x: 15,
            y: -40,
            ease: Phaser.Math.Easing.Quadratic.In,
            duration: 250 / GameVars.gameSpeed,
            delay: (delay + 100) / GameVars.gameSpeed, 
            onComplete: () => {
                this.cards[1].setFrame(GameVars.cardFrameName(cards[1]) + ".png");
                AudioManager.playSound("card_reveal_" + (Math.floor(Math.random() * 3) + 1));
                this.updateHand();
            },
            onCompleteScope: this
        });

        this.scene.tweens.add({
            targets: this.cards[0],
            alpha: 1,
            delay: delay / GameVars.gameSpeed,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 100 / GameVars.gameSpeed
        });

        this.scene.tweens.add({
            targets: this.cards[1],
            alpha: 1,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 100 / GameVars.gameSpeed,
            delay: (delay + 100) / GameVars.gameSpeed
        });
    }

    public showPlayerCards(): void {

        if (this.cards[0].scaleX === .65) {
            return;
        }

        let position = 0;
        for (let i = 0; i < GameVars.gameState.players.length; i++) {
            if (this.id === GameVars.gameState.players[i].id) {
                break;
            } else {
                position++;
            }
        }
        
        this.scene.tweens.add({
            targets: this.cards[1],
            scaleX: .65,
            scaleY: .65,
            y: this.cards[1].y - 40,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500 / GameVars.gameSpeed,
            delay: (position * 100) / GameVars.gameSpeed
        });

        this.scene.tweens.add({
            targets: this.cards[0],
            scaleX: .65,
            scaleY: .65,
            y: this.cards[0].y - 40,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500 / GameVars.gameSpeed,
            delay: (250 + (position * 100)) / GameVars.gameSpeed,
        });


        this.scene.tweens.add({
            targets: this.cards[1],
            x: this.cards[1].x  - 18,
            angle: 10,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500 / GameVars.gameSpeed,
            delay: (position * 100) / GameVars.gameSpeed
        });

        this.scene.tweens.add({
            targets: this.cards[0],
            x: this.cards[0].x  + 18,
            angle: -10,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 500 / GameVars.gameSpeed,
            delay: (250 + (position * 100)) / GameVars.gameSpeed,
            onComplete: () => {
                AudioManager.playSound("card_reveal_" + (Math.floor(Math.random() * 3) + 1));
            },
            onCompleteScope: this
        });
    }

    public addWageredToPot(): void {

        if (this.chipsContainer.visible) {
            this.scene.tweens.add({
                targets: this.chipsContainer,
                x: (GameConstants.GAME_WIDTH / 2 - this.x) / (GameVars.scaleX * .9),
                y: (GameConstants.GAME_HEIGHT / 2 - this.y - 50) / .9,
                ease: Phaser.Math.Easing.Linear.Linear,
                duration: 250 / GameVars.gameSpeed,
                onComplete: () => {
                    this.chipsContainer.visible = false;
                },
                onCompleteScope: this
            });
        }
    }

    public potToPlayer(): void {

        this.chipsContainer.creditsLabel.setFill("#89E09D");

        this.chipsContainer.x = (GameConstants.GAME_WIDTH / 2 - this.x) / (GameVars.scaleX * .9);
        this.chipsContainer.y = (GameConstants.GAME_HEIGHT / 2 - this.y - 50) / .9;
        this.chipsContainer.visible = true;
        this.chipsContainer.alpha = 1;

        this.scene.tweens.add({
            targets: this.chipsContainer,
            x: 0,
            y: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250 / GameVars.gameSpeed,
            onComplete: () => {
                this.chipsContainer.visible = false;
                this.updateChips();
            },
            onCompleteScope: this
        });
    }

    public updateHand(): void {

        if (RoomManager.getPlayer(this.id)) {
            let cards = GameVars.gameState.community.concat(RoomManager.getPlayer(this.id).cards);
            this.handLabel.setText(Hand.solve(cards).name.toUpperCase());

            if (this.prevHandLabel !== "" && this.prevHandLabel !== this.handLabel.text) {

                this.scene.tweens.add({
                    targets: this.handLabel,
                    scaleX: 1.1,
                    scaleY: 1.1,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500 / GameVars.gameSpeed,
                    yoyo: true,
                    repeat: 1
                });
            }

            this.prevHandLabel = Hand.solve(cards).name.toUpperCase();
        } 
    }

    public setDealer(isDealer: boolean): void {

        this.isDealer = isDealer;
        this.dealerChip.visible = this.isDealer;
    }

    public updateBet(type?: string): void {

        const player = RoomManager.getPlayer(this.id);

        if (player.wagered > 0) {
            this.chipsContainer.show();
            this.chipsContainer.setCredits(player.wagered + player.poted);

            const credits = player.chips - player.wagered;
            this.creditsLabel.text = GameVars.formatNumber(credits);
        }

        if (type) {

            this.creditsLabel.text = type.replace("_", " ").toUpperCase();
            switch (type) {
                case GameConstants.CALL:
                case GameConstants.CHECK:
                    this.creditsLabel.setFill("#ECA62F");
                    break;
                case GameConstants.FOLD:
                    this.creditsLabel.setFill("#22A6BD");
                    break;
                case GameConstants.RAISE:
                case GameConstants.ALL_IN:
                    this.creditsLabel.setFill("#DA314F");
                    break;
                default:
                    break;
            }

            if (type === GameConstants.ALL_IN) {

                let fire = this.scene.add.sprite(-20, -100, "texture_atlas_1", "fire_raise_00.png");
                fire.anims.play("fire_raise");
                fire.setScale(1.2);
                this.add(fire);

                AudioManager.playSound("all_in_fire_fx");

                fire.on("animationcomplete", () => {
                    fire.destroy();
                }, this);
            }

            AudioManager.playSound(type + "_" + (Math.floor(Math.random() * 2) + 1));

            this.scene.time.addEvent({delay: 1000 / GameVars.gameSpeed, callback: () => {

                let player = RoomManager.getPlayer(this.id);
                const credits = player.chips - player.wagered;

                this.creditsLabel.text = GameVars.formatNumber(credits);
                this.creditsLabel.setFill("#8d8065");
                
            }, callbackScope: this});
        }
    }

    public updateChips(): void {

        let player = RoomManager.getPlayer(this.id);

        if (player) {
            const credits = player.chips - player.wagered;
            this.creditsLabel.text = GameVars.formatNumber(credits);
        }
    }

    public resetBet(): void {

        // this.chipsContainer.hide();

        this.addWageredToPot();

        // let player = RoomManager.getPlayer(this.id);

        // if (player) {
        //     const credits = player.chips - player.wagered;
        //     this.creditsLabel.text = GameVars.formatNumber(credits);
        // }
    }

    public inactive(): void {

        this.cards[0].alpha = .5;
        this.cards[1].alpha = .5;
    }

    public showWinner(): void {

        this.confetti.visible = true;
        this.confetti.anims.play("confetti", true);

        AudioManager.playSound("confetti");
        
        if (RoomManager.playersActive().length > 1) {
            AudioManager.playSound("player_wins_hand");

            this.scene.tweens.add({
                targets: this,
                scaleX: GameVars.scaleX,
                scaleY: 1,
                ease: Phaser.Math.Easing.Bounce.Out,
                duration: 500,
                onComplete: () => {
                    this.scene.tweens.add({
                        targets: this,
                        scaleX: .9 * GameVars.scaleX,
                        scaleY: .9,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 500,
                        delay: 500
                    });
                },
                onCompleteScope: this
            });
        }
        
    }

    public resetTable(): void {

        this.cards[0].visible = false;
        this.cards[1].visible = false;

        this.container.sendToBack(this.cards[0]);
        this.container.sendToBack(this.cards[1]);
        
        this.cards[0].alpha = 1;
        this.cards[1].alpha = 1;

        this.prevHandLabel = "";

        this.confetti.visible = false;
        
        this.resetBet();

        this.handLabel.setText("");

        for (let i = 0; i < this.frames.length; i++) {
            this.container.remove(this.frames[i]);
        }
        this.frames = [];
    }

    public eliminatePlayer(): void {

        if (!this.visible) {
            return;
        }

        let banana = new BananaSpine(this.scene);
        banana.x = 65;
        banana.y -= 160;
        this.add(banana);

        AudioManager.playSound("puf");

        banana.setAvatarState("eliminacion");

        let newX = 0;
        let newY = 500;

        this.scene.tweens.add({
            targets: [this.cards[0], this.cards[1]],
            alpha: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 500 / GameVars.gameSpeed,
            delay: 1500 / GameVars.gameSpeed,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this.container,
                    x: this.container.x + newX,
                    y: this.container.y + newY,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500 / GameVars.gameSpeed,
                    onComplete: () => {
                        this.container.visible = false;
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });

        this.scene.time.addEvent({delay: 3500 / GameVars.gameSpeed, callback: () => {
            this.visible = false;
        }, callbackScope: this});
    }
}
